// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90bf195e","455":"79784983","977":"85d48df6"}[chunkId] + ".chunk.js";
};